import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=65c5d542&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=65c5d542&lang=css"
import style1 from "./AddDepartment.vue?vue&type=style&index=1&id=65c5d542&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5d542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c5d542')) {
      api.createRecord('65c5d542', component.options)
    } else {
      api.reload('65c5d542', component.options)
    }
    module.hot.accept("./AddDepartment.vue?vue&type=template&id=65c5d542&scoped=true", function () {
      api.rerender('65c5d542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AddDepartment.vue"
export default component.exports